<template>
  <div>
    <template v-if="serviceOption === 'ANY'">any</template>
    <template v-else-if="serviceOption === 'DEFAULT'"
      >Application-default</template
    >
    <template v-else>
      <p v-for="(e, i) in customServices" :key="`custom_${i}`">
        {{ e.serviceName }}
      </p>
      <p v-for="(e, i) in defaultServices" :key="`default_${i}`">
        {{ e.serviceName }}
      </p>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CommonPolicy, GetPolicy } from "@/apis/NwPolicyApi";

/** インターネットType1,4のポリシーのサービス表示が出来るコンポーネント */
export default defineComponent({
  name: "PolicyService",
  props: {
    /** サービス選択オプション */
    serviceOption: {
      type: String as PropType<CommonPolicy["serviceOption"]>,
      required: true,
    },
    /** デフォルトサービスリスト */
    defaultServiceList: {
      type: Array as PropType<GetPolicy["defaultServiceList"]>,
      required: true,
    },
    /** カスタムサービスリスト */
    customServiceList: {
      type: Array as PropType<GetPolicy["customServiceList"]>,
      required: true,
    },
  },
  computed: {
    /** 昇順ソート済みのデフォルトサービスリスト */
    defaultServices(): GetPolicy["defaultServiceList"] {
      return this.defaultServiceList.sortBy(["serviceName", "asc"]);
    },
    /** 昇順ソート済みのカスタムサービスリスト */
    customServices(): GetPolicy["customServiceList"] {
      return this.customServiceList.sortBy(["serviceName", "asc"]);
    },
  },
});
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>
